<template>
	<a-table
		:columns="columns"
		:data-source="tableDatas"
		:pagination="false"
		bordered
	></a-table>
</template>

<script setup>
	import { ref, defineProps, watch } from "vue";
	import { toFixed } from "@/plugins/index.js";
	import { makeTotalData } from "../plugin";

	const props = defineProps({
		yearProfitInfos: {
			type: Object,
			default: () => {
				return null;
			}
		}
	});

	const columns = ref([
		{
			title: "年份",
			dataIndex: "year",
			key: "year"
		},
		{
			title: "放电收益(万元)",
			dataIndex: "dischargeProfit",
			key: "dischargeProfit"
		},
		{
			title: "投资方分成比例",
			dataIndex: "sharingRatio",
			key: "sharingRatio"
		},
		{
			title: "投资方分成收益(万元)",
			dataIndex: "investorProfit",
			key: "investorProfit"
		},
		{
			title: "业主分成收益(万元)",
			dataIndex: "ownerProfit",
			key: "ownerProfit"
		}
	]);
	const tableDatas = ref([]);

	// 生成数据
	const makeTableData = (lists = []) => {
		let arr = [];
		lists.map((el, index) => {
			arr.push({
				year: index + 1,
				dischargeProfit: toFixed(el.dischargeProfit / 10000),
				sharingRatio: `${toFixed(el.sharingRatio)}%`,
				investorProfit: toFixed(el.investorProfit / 10000),
				ownerProfit: toFixed(el.ownerProfit / 10000)
			});
		});
		let totalRow = makeTotalData(
			lists,
			["dischargeProfit", "investorProfit", "ownerProfit"],
			["sharingRatio"]
		);
		console.log(totalRow);
		tableDatas.value = [...arr, totalRow];
	};

	watch(
		() => props.yearProfitInfos,
		newVal => {
			console.log(newVal);
			if (newVal) {
				// 生成数据
				makeTableData(newVal);
			}
		},
		{ immediate: true, deep: true }
	);
</script>
<style lang="less" scoped>
::v-deep .ant-table-cell {
	padding: 11px 16px !important;
}
</style>